// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-29f1675f] .el-dialog__body{padding:10px 20px 40px 20px}#pageIndex[data-v-29f1675f]{width:100%;height:100%;overflow:hidden}", ""]);
// Exports
module.exports = exports;
